import { Component, type ErrorInfo, type ReactNode } from 'react';
import { LiksErrorFallback } from './LiksErrorFallback';
import type { LiksErrorFallbackVariant } from './LiksErrorFallback';

export type LiksErrorBoundaryProps = {
  children: ReactNode;
  variant?: LiksErrorFallbackVariant;
  showGoHome?: boolean;
};

type LiksErrorBoundaryState = {
  error: Error | null;
};

export class LiksErrorBoundary extends Component<
  LiksErrorBoundaryProps,
  LiksErrorBoundaryState
> {
  state: LiksErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): LiksErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('LiksErrorBoundary caught a render error', error, info);
  }

  private handleRetry = (): void => {
    this.setState({ error: null });
  };

  private handleReload = (): void => {
    window.location.reload();
  };

  render(): ReactNode {
    if (this.state.error != null) {
      return (
        <LiksErrorFallback
          variant={this.props.variant ?? 'full'}
          showGoHome={this.props.showGoHome}
          onRetry={this.handleRetry}
          onReload={this.handleReload}
        />
      );
    }

    return this.props.children;
  }
}
